import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="legal-container">
      <h1>Privacy Policy</h1>
      <p>Last Updated: May 5, 2026</p>

      <section>
        <h2>1. Information Collection</h2>
        <p>We collect information you provide directly to us, such as when you create an account, fill out a form, or communicate with us.</p>
      </section>

      <section>
        <h2>2. SMS Information and Privacy</h2>
        <p>We respect your privacy. We will only use information you provide through the Program to transmit your mobile messages and respond to you, if necessary. This includes sharing information with platform providers, phone companies, and other vendors who assist us in the delivery of mobile messages.</p>
        <p><strong>No mobile information will be shared with third parties/affiliates for marketing/promotional purposes. All the above categories exclude text messaging originator opt-in data and consent; this information will not be shared with any third parties.</strong></p>
      </section>

      <section>
        <h2>3. Data Security</h2>
        <p>We take reasonable measures to help protect information about you from loss, theft, misuse and unauthorized access, disclosure, alteration and destruction.</p>
      </section>

      <section>
        <h2>4. Contact Us</h2>
        <p>If you have any questions about this Privacy Policy, please contact us at g.nunez.2803@gmail.com.</p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
